export function autoParagraph(content) {
  return `<p>${content.replace(/\n/g, '</p><p>')}</p>`;
}


export function autoBr(content) {
  return content.replace(/\n/g, '<br />');
}

export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function removePWrap(content) {
  return content.replace(/(?:^<p[^>]*>)|(?:<\/p>$)/g, '');
}

// Export
export default autoParagraph;



// WEBPACK FOOTER //
// ./src/app/helpers/content.js